import { CardView, rem, SettingsItem, SettingsItemRightContent, SettingsItemSwitch, } from 'design-system';
import { IconArrowBack } from 'design-system/icons';
import SubscriptionFrequencyModalContent from 'features/subscriptions/components/modal/SubscriptionFrequencyModalContent';
import React, { useCallback } from 'react';
import Text from 'design-system/Text';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import Amount from 'design-system/Amount';
import { formatDateForItem } from 'utils';
import { toZonedTime } from 'date-fns-tz';
import { isWeb } from '../../../constants';
const strings = {
    recurring: 'Set as recurring',
    frequencyModalTitle: 'How often should this repeat?',
    frequencyDescription: 'Next scheduled transaction',
};
const RecurringTransactionsSwitch = ({ recurring, setRecurring, frequency, setFrequency, amount, nextOccurrence, }) => {
    const localDate = nextOccurrence
        ? toZonedTime(nextOccurrence, Intl.DateTimeFormat().resolvedOptions().timeZone)
        : null;
    const handleToggle = useCallback(() => {
        const onSelect = (f) => {
            setFrequency(f);
            if (!f) {
                setRecurring(false);
            }
            Modal.hide();
        };
        setRecurring(true);
        Modal.show(<SubscriptionFrequencyModalContent paymentFrequency={frequency} onSelect={onSelect} title={strings.frequencyModalTitle} showSaveButton/>, {
            increasedTopPadding: true,
            title: isWeb ? strings.frequencyModalTitle : undefined,
            onBackdropPress() {
                if (!frequency) {
                    setRecurring(false);
                }
            },
            onSwipeComplete() {
                if (!frequency) {
                    setRecurring(false);
                }
            },
            onPressClose() {
                if (!frequency) {
                    setRecurring(false);
                }
            },
        });
    }, [frequency, setFrequency, setRecurring]);
    return (<CardView noMarginBottom>
      {!!recurring && !!frequency && !!localDate ? (<SettingsItem style={styles.container} title={formatDateForItem(localDate)} descriptionStyle={styles.frequencyDescriptionContainer} description={<>
              <Text TextThin-14 Gray>
                {strings.frequencyDescription}
              </Text>
              <IconArrowBack width={28} height={16} gradientKey="darkPink"/>
            </>} onPress={handleToggle}>
          <SettingsItemRightContent>
            <Amount Numbers-16 value={{
                amount: amount?.amount || 0,
                currency: amount?.currency || '',
            }} showSign scramblable={false}/>
          </SettingsItemRightContent>
        </SettingsItem>) : (<SettingsItemSwitch title={strings.recurring} style={styles.container} value={recurring} onValueChange={handleToggle} icon={<IconArrowBack gradientKey="darkPink"/>}/>)}
    </CardView>);
};
const styles = StyleSheet.create({
    container: {
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    frequencyDescriptionContainer: {
        marginTop: rem(4),
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(4),
    },
});
export default RecurringTransactionsSwitch;
